import React from 'react';

export default function renderComponent(props) {
    const { children, ...rest } = { ...props };

    if (children) {
        if (typeof children === 'function') {
            return children(rest);
        } else if (!Array.isArray(props.children) || !children.length) {
            if (typeof children.type === 'function') {
                return React.cloneElement(children, rest);
            } else {
                return React.cloneElement(children);
            }
        }
    } else {
        return null;
    }
}
